export enum IBreakpointsEnum {
  XS = 576,
  SM = 768,
  MD = 992,
  LG = 1200,
  XL = 1920,
}

export const THRESHOLD = IBreakpointsEnum.MD;
